import { createApp } from "vue";
import { createPinia } from "pinia";
import "element-plus/dist/index.css";
import "@/stores/index.ts";
import App from "./App.vue";
import router from "./router";
// import "@/router/permission.ts";
import "@/styles/index.scss";

const app = createApp(App);
const modules = [router];
for (const moduleItem of modules) {
  app.use(moduleItem);
}
app.use(createPinia());
app.mount("#app");
